<template>
  <div>
    <b-row class="header-zone">
      <b-col class="d-flex align-items-center">
        <div class="d-flex align-items-center">
          <span class="ap-title ap-title__main">{{ $t('diagnosis.notificationsModal.notificationsSent') }}</span>
        </div>
      </b-col>
      <b-col cols="auto">
        <div>
          <b-button
            qa="custom-sent-notifications-grid-back-button"
            class="btn__link px-3"
            @click="$emit('changeView')"
          >
            <i
              class="far fa-chevron-left mr-2"
              aria-hidden="true"
            />
            {{ $t('diagnosis.notificationsModal.back') }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col
        cols="12"
        class="d-flex flex-column p-0"
      >
        <custom-sent-notifications-sidepanel
          v-if="infoSidepanel"
          :notification="clickedNotification"
          @closeInfoSidepanel="infoSidepanel = false"
        />
        <vt-grid
          qa="custom-sent-notifications-grid-elements-div"
          class="sent-notification-grid"
          :grid-options="gridOptions"
          :row-data="rowData"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import columnsCustomSentNotificationsGrid
    from '@/modules/diagnosisModule/views/grid/customSentNotifications/config/columnsCustomSentNotificationsGrid'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import CustomSentNotificationsSidepanel
    from '@/modules/diagnosisModule/views/grid/customSentNotifications/customSentNotificationsSidepanel'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'CustomSentNotificationsGrid',
    components: { CustomSentNotificationsSidepanel, VtGrid },
    props: {
        rowData: Array
    },
    data() {
        return {
            columnDefs: columnsCustomSentNotificationsGrid(),
            infoSidepanel: false,
            clickedNotification: null
        }
    },
    computed: {
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                onRowClicked: this.showNotificationInfoSidepanel,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: params => {
                    this.onGridReady(params)
                }
            }
        }
    },
    methods: {
        showNotificationInfoSidepanel(params) {
            this.clickedNotification = params?.node.data
            this.infoSidepanel = true
        },
        getContextMenuItems(params) {
            return [
                {
                    name: this.$t('global.showInformation'),
                    action: () => this.showNotificationInfoSidepanel(params)
                }
            ]
        },
        async onGridReady(api) {
            this.gridApi = api.api
            this.columnApi = api.columnApi
        }
    }
}
</script>

<style scoped>

</style>
